var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pdfSrc)?_c('a',{attrs:{"href":_vm._f("imagePath")(_vm.pdfSrc,'statement', 'default', true),"target":"_blank"}},[_c('b-icon-download',{attrs:{"variant":"primary","font-scale":"1.3"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }